export const saveExcel = (filename, data) => {
  const isSemicolon = data.includes(';')
  const encoding = 'utf-8'
  const mimeType = `text/csv;charset=${encoding};`
  filename = `${filename}.csv`
  // для экселей используется utf-8 BOM формат для поддержки русского в экселях
  const content = isSemicolon ? '\uFEFF' + data : data
  const file = new Blob([content], { type: mimeType })

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file, filename)
    return
  }
  const a = document.createElement('a')
  const url = URL.createObjectURL(file)
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()

  setTimeout(() => {
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  }, 0)
}
